import {
  Create,
  Edit,
  SaveButton,
  SimpleForm,
  Toolbar,
  useRefresh,
  useNotify,
  Button,
} from "react-admin";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { RazaBackedEventFormFields } from "@/components/raza/RazaBackedEventFormFields";
import {
  buildRazaBackedEventCreatePayload,
  stripReadOnlyRazaEventFields,
} from "@/utils/raza-request-event-payload";

function DialogToolbar({ onCancel }: { onCancel: () => void }) {
  return (
    <Toolbar sx={{ bgcolor: "transparent", boxShadow: "none", gap: 1 }}>
      <SaveButton />
      <Button label="Cancel" sx={{ py: 1, px: 2 }} onClick={onCancel} />
    </Toolbar>
  );
}

export function RazaRequestRazaEventCreateDialog({
  onClose,
  razaRequestId,
  defaultHostItsNo,
  defaultHostName,
  defaultRequestPurpose,
}: {
  onClose: () => void;
  razaRequestId: string;
  defaultHostItsNo?: string | null;
  defaultHostName?: string | null;
  /** Booking purpose id from the parent raza request */
  defaultRequestPurpose?: string | null;
}) {
  const refresh = useRefresh();
  const notify = useNotify();

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Add event</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Create
          resource="raza-events"
          title={false}
          actions={false}
          sx={{ boxShadow: "none", bgcolor: "transparent", "& .RaCreate-main": { mt: 0 } }}
          transform={(data: Record<string, unknown>) =>
            buildRazaBackedEventCreatePayload(data, razaRequestId)
          }
          mutationOptions={{
            onSuccess: () => {
              notify("Event created", { type: "success" });
              refresh();
              onClose();
            },
          }}
        >
          <SimpleForm
            warnWhenUnsavedChanges
            sx={{ maxWidth: 1120 }}
            defaultValues={{
              hostItsNo: defaultHostItsNo ?? "",
              hostName: defaultHostName ?? "",
              startTime: "09:00",
              purpose: defaultRequestPurpose ?? "",
              needSadaratMale: true,
              needSadaratFemale: false,
            }}
            toolbar={<DialogToolbar onCancel={onClose} />}
          >
            <RazaBackedEventFormFields />
          </SimpleForm>
        </Create>
      </DialogContent>
    </Dialog>
  );
}

export function RazaRequestRazaEventEditDialog({
  onClose,
  eventId,
}: {
  onClose: () => void;
  eventId: string;
}) {
  const refresh = useRefresh();
  const notify = useNotify();

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Edit event</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Edit
          key={eventId}
          resource="raza-events"
          id={eventId}
          mutationMode="pessimistic"
          redirect={false}
          actions={false}
          title={false}
          sx={{ boxShadow: "none", bgcolor: "transparent", "& .RaEdit-main": { mt: 0 } }}
          transform={stripReadOnlyRazaEventFields}
          mutationOptions={{
            onSuccess: () => {
              notify("Event updated", { type: "success" });
              refresh();
              onClose();
            },
          }}
        >
          <SimpleForm
            warnWhenUnsavedChanges
            sx={{ maxWidth: 1120 }}
            toolbar={<DialogToolbar onCancel={onClose} />}
          >
            <RazaBackedEventFormFields />
          </SimpleForm>
        </Edit>
      </DialogContent>
    </Dialog>
  );
}
